import Monitor from '@/common/monitor';

class Performance {
  constructor(config = {}) {
    const SEC = 1000;
    const { domTimeout = 4, resTimeout = 10 } = config;
    // 设定超时时间
    this.domTimeout = domTimeout * SEC;
    this.resTimeout = resTimeout * SEC;
    // 绑定监控
    this.monitor = Monitor.getInstance({
      environment: process.env.VUE_APP_PACK_MODE,
    });

    this.init();
  }

  static getDomCompleteTime() {
    if (!window.performance || typeof window.performance.getEntriesByType !== 'function') return 0;
    const navigation = window.performance.getEntriesByType('navigation');
    if (navigation.length > 0 && navigation[0] && navigation[0].domComplete) {
      return navigation[0].domComplete;
    }
    return 0;
  }

  getTimeoutRes() {
    const { resTimeout } = this;
    const setTime = limit => time => time >= limit;
    const isTimeout = setTime(resTimeout);
    const getDiffTime = ({ startTime, responseEnd }) => responseEnd - startTime;
    const getData = ({ name, startTime, responseEnd }) => ({ name, startTime, responseEnd });
    const resourceTimes = window.performance.getEntriesByType('resource');
    return resourceTimes
      .filter(item => isTimeout(getDiffTime(item)))
      .map(getData);
  }

  init() {
    const domCompleteTime = Performance.getDomCompleteTime();
    const timeoutResources = this.getTimeoutRes();
    const { domTimeout, resTimeout } = this;
    if (domCompleteTime > domTimeout) {
      this.log({ domCompleteTime }, `DOM Performance timeout ${domTimeout}ms`);
    }
    timeoutResources.forEach((item) => {
      this.log(item, `Resource Performance timeout ${resTimeout}ms`);
    });
  }

  log(data, msg = '', type = 'warning') {
    this.monitor.log(data, type, msg);
  }
}

export default Performance;
